'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSellerRecordResultsIfNeeded = exports.getSellerRecordResults = exports.isSellerRecordResultsLoading = exports.getLoadTimeForRecordResults = exports.getSellerRecordResultsIds = exports.LOAD_SELLER_RECORD_RESULTS_SUCCESS = exports.LOAD_SELLER_RECORD_RESULTS_REQUEST = exports.LOAD_SELLER_RECORD_RESULTS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _user = require('../modules/user');

var _config = require('../modules/config');

var _cardData = require('../modules/cardData');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_SELLER_RECORD_RESULTS_FAIL = exports.LOAD_SELLER_RECORD_RESULTS_FAIL = 'la/domain/sellerRecordResults/LOAD_FAIL';
var LOAD_SELLER_RECORD_RESULTS_REQUEST = exports.LOAD_SELLER_RECORD_RESULTS_REQUEST = 'la/domain/sellerRecordResults/LOAD_REQUEST';
var LOAD_SELLER_RECORD_RESULTS_SUCCESS = exports.LOAD_SELLER_RECORD_RESULTS_SUCCESS = 'la/domain/sellerRecordResults/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_SELLER_RECORD_RESULTS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.sellerId])
            });
        case LOAD_SELLER_RECORD_RESULTS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_SELLER_RECORD_RESULTS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.items) {
                var sellerRecordResults = action.payload.items;
                var sellerId = sellerRecordResults[0].sellerId; // TODO: maybe we should use the sellerId from the meta
                existing[sellerId] = action.payload.items.map(function (item) {
                    return item.itemId;
                });
                loaded[sellerId] = time;
                loading = (0, _difference2.default)(loading, [sellerId]);
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.sellerRecordResults;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns the data
var getSellerRecordResultsIds = exports.getSellerRecordResultsIds = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || [];
});

// takes in a (state, id) and returns the load time
var getLoadTimeForRecordResults = exports.getLoadTimeForRecordResults = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns the is loading
var isSellerRecordResultsLoading = exports.isSellerRecordResultsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.indexOf(id) !== -1;
});

var getSellerRecordResults = exports.getSellerRecordResults = function getSellerRecordResults(state, sellerId) {
    var itemIds = getSellerRecordResultsIds(state, sellerId);
    return (0, _cardData.getItemCardDatas)(state, itemIds);
};

var shouldFetchSellerRecordResults = function shouldFetchSellerRecordResults(state, sellerId) {
    if (!sellerId) return false;
    var items = getSellerRecordResults(state, sellerId);
    if (items.length) {
        var loaded = getLoadTimeForRecordResults(state, sellerId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSellerRecordResultsLoading(state, sellerId);
    return !loading;
};

/* ACTION CREATORS */
var loadSellerRecordResults = function loadSellerRecordResults(sellerId) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: sellerId,
                                type: LOAD_SELLER_RECORD_RESULTS_REQUEST
                            });
                            _context.next = 7;
                            return _api.SellerRecordResults.fetchSellerRecordResultsById({
                                authToken: authToken,
                                deployment: deployment,
                                sellerId: sellerId
                            });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), sellerId: sellerId },
                                payload: response.data,
                                type: LOAD_SELLER_RECORD_RESULTS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { sellerId: sellerId },
                                payload: _context.t0,
                                type: LOAD_SELLER_RECORD_RESULTS_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchSellerRecordResultsIfNeeded = exports.fetchSellerRecordResultsIfNeeded = function fetchSellerRecordResultsIfNeeded(sellerId) {
    return function (dispatch, getState) {
        if (shouldFetchSellerRecordResults(getState(), sellerId)) {
            return dispatch(loadSellerRecordResults(sellerId));
        }

        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/sellerRecordResults.js
// module id = TaFV
// module chunks = 46